// external libraries
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import classNames from "classnames";

// hooks and state
import { useAuth } from "../../contexts/AuthContext";

// components
import { Tabs, type TabType } from "@happy-doc/shared-components";
import ProfileMenu from "./ProfileMenu";

const Navbar = () => {
	const { account } = useAuth();
	const location = useLocation();
	const navigate = useNavigate();

	const DashboardTab = {
		header: "Dashboard",
		isActive: location.pathname === '/',
		id: '/',
	}

	const [tabs, setTabs] = useState<TabType[]>([DashboardTab]);

	useEffect(() => {
		setTabs((prev) =>
			prev.map((t) => {
				if (t.id.split('?')[0] === location.pathname) {
					return { ...t, isActive: true, };
				} else {
					return { ...t, isActive: false, };
				}
			}),
		);
	}, [location.pathname]);

	/**
	 * Change the tab and update the current stage in redux
	 * @param id - The id of the tab
	 */
	const changeTab = (id: string) => {

		if (location.pathname === id.split('?')[0]) {
			return;
		}

		setTabs((prev) =>
			prev.map((t) => {
				if (t.id === id) {
					return { ...t, isActive: true, };
				} else {
					return { ...t, isActive: false, };
				}
			}),
		);

		// check to see if we are navigating to the dashboard
		if (id === "/") {
			// if so, we remove the page param and navigate
			navigate({ pathname: id, search: '' });
		}
	};

	const handleLogoClick = () => {
		// navigate to home. note that Visit.tsx manages the correct list vs. calendar page state
		navigate('/');
	}

	return (
		<div className="flex-col bg-gray-100">
			<div
				className={classNames(
					"flex h-16 shrink-0 items-center border-b border-gray-200 bg-gray-100 px-4 "
				)}
			>
				<div className="w-full flex items-center flex-1 gap-x-5 self-stretch">
					<button className="focused" onClick={handleLogoClick}>
						<img src="/happydoc.svg" alt="logo" className="hidden sm:inline h-8 w-auto  " />
						<img src="/favicon.png" alt="logo" className="sm:hidden h-8 w-auto " />
					</button>
					<h1 className="hidden lg:inline-flex text-xl font-semibold leading-6 text-gray-900">{account?.clinic_name || ""}</h1>
					<div className=" ">
						<Tabs tabs={tabs} changeTab={changeTab} paddingVertical="py-5  sm:py-[18px]" />
					</div>
				</div>

				<div className="flex items-center gap-x-2 ml-auto">
					<ProfileMenu />
				</div>
			</div>
		</div>

	);
};
export default Navbar;
